export function formatPrice(price?: number): string {
	if (!price) {
		return 'gratis';
	}

	return `&euro; ${price.toFixed(2).replace('.', ',')}`;
}
